import { getFieldRegistration, ssoLink, updateFieldNew } from "@common/api"
import { accessToken, timeStamp } from "@common/utils"
import {
    mandatory_no_require,
    mandatory_require,
    type_checkbox,
    type_image, type_product_type,
    type_radio,
    type_text
} from "@common/constact"
import { uuid } from "@common/utils"
import { valueDuoxuanForPostStr, } from "@common/utils"
import { isNil } from "@common/utils"
import { get_exhibit_field_value, get_exhibit_fields } from "../toSupplierDetail/api"
import { post_update_exhibit_value } from "./api"
import { bodyAndValue2postObject } from "@common/utils"
import ajax from "@common/utils/ajax"

var initState = {
    id: "",
    exhibitId: "",
    userId: "",
    projectName: "",
    projectId: "",
    bodyMap: {},
    bodys: [],
    supplierMap: {},
    supplierMapAndbodys: [], //value
    isEdit: false,
    validateMessage: "",
    cascades: [],
}
export default {
    namespaced: true,
    state: initState,
    getters: {},
    mutations: {
        set_exhibitId (state, exhibitId) {
            state.exhibitId = exhibitId
        },
        set_projectName (state, projectName) {
            state.projectName = projectName
        },
        set_projectId (state, projectId) {
            state.projectId = projectId
        },
        set_userId (state, userId) {
            state.userId = userId
        },
        set_body (state, res) {
            state.bodys = res.body || res.defaults
            state.cascades = res.cascades
        },
        togget_isEdit (state) {
            state.isEdit = !state.isEdit
        },
        set_isEdit_false (state) {
            state.isEdit = false
        },
        set_supplierMap (state, supplierMap) {
            state.supplierMap = supplierMap || {}
            state.supplierMapAndbodys = state.bodys && state.bodys.map(item => {
                item.value = state.supplierMap[item.nameKey]
                return item
            })
        },
        set_messageError (state, validateMessage) {
            state.validateMessage = validateMessage
        },
        set_supplierMapAndbodys (state, supplierMapAndbodys) {
            state.supplierMapAndbodys = supplierMapAndbodys
        }
    },
    actions: {
        async actions_fetch_get_body ({ state, commit }, params) {

            // get body
            let params1 = {
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                src: '2',
                projectId: state.projectId
            }
            var consumerId = sessionStorage.getItem('companyId')
            var userId = sessionStorage.getItem('userId')
            await ajax.post(`/api3/backend/v1/${consumerId}/match/${userId}/v1/queryRegistration/`, params1)
                .then(res => res.data).then(res => {
                    if (res.code != 0) {
                        throw res
                    }
                    commit("set_body", res.data)
                })
            //get supplierMap
            return get_exhibit_field_value({
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                projectId: state.projectId,
                id: state.exhibitId,
            }).then(res => {
                if (res.code != 0) {
                    throw res
                }
                commit("set_supplierMap", res.result)
            })
        },
        actions_validate_saveEdit ({ state, commit }) {
            //   那些必选拿到如果没有的话
            commit('set_messageError', ``)
            state.supplierMapAndbodys.map(item => {
                if (item.mandatory === mandatory_require && isNil(item.value)) {
                    commit('set_messageError', `${item.nameZh}必填`)
                    return false
                }
            })
            return !state.validateMessage

        },
        actions_uplodeFields ({ state, commit }, params) {

        },
        actions_add_type ({ state, commit }, type) {

        },
        actions_saveEdit ({ state, commit }) {
            var data = bodyAndValue2postObject(state.supplierMapAndbodys)
            data.id = state.exhibitId
            /* if(data.cover_image){
                 if(!data.product_image1){
                     data.product_image1=data.cover_image
                 }else if(!data.product_image2){
                     data.product_image2=data.cover_image
                 }
             }*/
            return post_update_exhibit_value(data)
        },

    }
}


// WEBPACK FOOTER //
// ./src/admin/components/organizer/toExhibitsDetail/toExhibitsDetailStore.js